export const plDict = {
  'Back to Sign In': 'Powrót do logowania',
  Birthdate: 'Data urodzenia',
  'Change Password': 'Zmień hasło',
  Changing: 'Zmienianie',
  Code: 'Kod',
  'Confirm Password': 'Potwierdź Hasło',
  'Reset your Password': 'Zresetuj swoje hasło',
  'Confirm Sign Up': 'Potwierdź rejestrację',
  'Confirm SMS Code': 'Potwierdź kod SMS',
  'Confirm TOTP Code': 'Potwierdź hasło jednorazowe',
  Confirm: 'Potwierdź',
  'Confirmation Code': 'Kod potwierdzenia',
  Confirming: 'Potwierdzanie',
  'Create Account': 'Utwórz konto',
  'Creating Account': 'Tworzenie konta',
  Email: 'E-mail',
  'Enter your code': 'Wprowadź swój kod',
  'Enter your username': 'Wprowadź swoją nazwę użytkownika',
  'Family Name': 'Nazwisko',
  'Given Name': 'Pierwsze imię',
  'Forgot your password?': 'Zapomniałeś hasła? ',
  'Hide password': 'Ukryj hasło',
  Loading: 'Ładowanie',
  Username: 'Nazwa użytkownika',
  'Middle Name': 'Drugie imię',
  Name: 'Imię i nazwisko',
  Nickname: 'Pseudonim',
  'New password': 'Nowe hasło',
  Password: 'Hasło',
  'Phone Number': 'Numer telefonu',
  'Preferred Username': 'Preferowana nazwa użytkownika',
  Profile: 'Profil',
  'Resend Code': 'Wyślij kod ponownie',
  'Reset your password': 'Zresetuj swoje hasło',
  'Send Code': 'Zresetuj hasło',
  'Send code': 'Wyślij kod',
  Sending: 'Wysyłanie',
  'Setup TOTP': 'Konfiguruj TOTP',
  'Show password': 'Pokaż hasło',
  'Sign in': 'Zaloguj',
  'Sign In': 'Logowanie',
  'Sign In with Amazon': 'Zaloguj z Amazon',
  'Sign In with Apple': 'Zaloguj z Apple',
  'Sign In with Facebook': 'Zaloguj z Facebook',
  'Sign In with Google': 'Zaloguj z Google',
  'Sign in to your account': 'Zaloguj się na swoje konto',
  'Create a new account': 'Utwórz nowe konto',
  'Signing in': 'Logowanie',
  Skip: 'Pomiń',
  Submit: 'Wyślij',
  Submitting: 'Wysyłanie',
  'Verify Contact': 'Weryfikacja danych kontaktowych',
  'Account recovery requires verified contact information':
    'Odzyskanie konta wymaga zweryfikowanych danych kontaktowych',
  Verify: 'Zweryfikuj',
  Website: 'Strona internetowa',
};
